module.exports = __webpack_public_path__ + "static/media/FORM1-milk-splash.08c4eec7.png";